import React from 'react';
import { useIntl } from 'react-intl';

import Button from '@mui/material/Button';

type Props = {
  onClick: () => void;
  totalAmount: string;
};

const PayButton: React.FC<Props> = ({ onClick, totalAmount }) => {
  const { formatMessage } = useIntl();
  return (
    <Button variant="contained" onClick={onClick}>
      {formatMessage(
        { id: 'payment.footer.actionButton.pay', defaultMessage: `Pay ${totalAmount}` },
        { sum: totalAmount },
      )}
    </Button>
  );
};

export default PayButton;
